const { useState, useEffect } = React;

const useWPAjaxQuery = (ajaxUrl, params) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const URLParams = Object.keys(params)
      .map((key) => `${key}=${params[key]}`)
      .join("&");
    try {
      const request = await fetch(`${ajaxUrl}?${URLParams}`);
      const response = await request.json();
      try {
        setData(JSON.parse(response?.data));
      } catch (error) {
        setData(response?.data);
      }
      setIsLoaded(true);
      setIsLoading(false);
    } catch (error) {
      setIsError(true);
      setError(error.message);
      setIsLoading(false);
    }
  };

  return { data, isLoading, isLoaded, isError, error };
};

export default useWPAjaxQuery;
